import { Route, Switch } from "react-router-dom";
import SearchLoggedInUserDetails from "./SearchLoggedInUserDetails";
import UserActivityDetails from "./UserActivityDetails";

const App = ({ match }) => (
  <Switch>
    <Route exact path={`${match.url}`} component={SearchLoggedInUserDetails} />
    <Route
      path={`${match.url}/user-activity-details/:id`}
      component={UserActivityDetails}
    />
  </Switch>
);

export default App;
